import { render, staticRenderFns } from "./Scorpio.vue?vue&type=template&id=a5c687fc&"
import script from "./Scorpio.vue?vue&type=script&lang=js&"
export * from "./Scorpio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports